export default "__VITE_ASSET__CGqCbHIw__"